import React from 'react';
export const PageLoader = () => {
  return <div className="min-h-[60vh] flex items-center justify-center" data-id="element-1404" data-mp="3qfxydy8hdcem">
      <div className="text-center" data-id="element-1405" data-mp="mhzjtg3a5ghi">
        <div className="inline-block w-10 h-10 border-3 border-gray-300 border-t-gray-800 rounded-full animate-spin mb-4" style={{
        borderWidth: '3px'
      }} data-id="element-1406" data-mp="metuq0uniels" />
        <p className="text-gray-500 text-sm font-medium" data-id="element-1407" data-mp="di33q2uyhpy2">Loading...</p>
      </div>
    </div>;
};